
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import Vue from 'vue/dist/vue';

require('./bootstrap');

window.Vue = Vue;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';

import VueAlert from '@vuejs-pt/vue-alert';
Vue.use(VueAlert);

import datePicker from 'vue-bootstrap-datetimepicker';
Vue.use(datePicker);

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

export const EventBus = new Vue();

import FlagStatusForm from './components/FlagStatusForm.vue';
import FlagStatusMessageReason from './components/FlagStatusMessageReason.vue';
import FlagStatusList from './components/FlagStatusList.vue';
import FlagStatusListItem from './components/FlagStatusListItem.vue';
import NotificationStatus from './components/NotificationStatus.vue';

Vue.component('flag-status-form', FlagStatusForm);
Vue.component('flag-status-message-model', FlagStatusMessageReason);
Vue.component('flag-status-list', FlagStatusList);
Vue.component('flag-status-list-item', FlagStatusListItem);
Vue.component('notification-status', NotificationStatus);

const app = new Vue({
    el: '#app',
    mounted() {

    }
});
